import React from 'react';

export const MarketExpertise: React.FC = () => {
  const expertise = [
    {
      title: 'Local Market Knowledge',
      description: 'We maintain deep expertise in local real estate markets across multiple regions. Our team continuously monitors market trends, tracks comparable sales, and analyzes neighborhood dynamics. This knowledge allows us to make informed offers that reflect current market conditions while moving quickly on opportunities. We understand which areas are appreciating, where rental demand is strongest, and how local factors impact property values.',
      stats: '50+ Markets'
    },
    {
      title: 'Property Analysis',
      description: 'Our evaluation process goes beyond surface-level assessments. We examine income and expense statements, review rent rolls, assess deferred maintenance, evaluate unit mix, and analyze potential for value enhancement. This thorough analysis enables us to see the true potential in properties that others might overlook. We can identify opportunities in buildings that need work, have management issues, or face temporary challenges.',
      stats: '1000+ Properties Evaluated'
    },
    {
      title: 'Transaction Expertise',
      description: 'Having completed numerous apartment building acquisitions, we understand the intricacies of these transactions. We know how to structure deals that work for both parties, navigate complex title issues, handle tenant transitions smoothly, and close efficiently. Our experience means fewer surprises and smoother transactions. We have seen and solved virtually every challenge that can arise in an apartment building sale.',
      stats: '15+ Years Experience'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Market Expertise You Can Trust
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our success in acquiring apartment buildings stems from our deep understanding of real estate markets, property valuation, and investment analysis. This expertise benefits you as a seller.
          </p>
        </div>

        <div className="space-y-8">
          {expertise.map((item, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex flex-col md:flex-row md:items-start gap-6">
                <div className="flex-shrink-0">
                  <div className="w-24 h-24 bg-teal-500 rounded-lg flex items-center justify-center">
                    <span className="text-white font-bold text-sm text-center px-2">
                      {item.stats}
                    </span>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-600 mb-2">$500M+</div>
            <div className="text-gray-600">Total Transaction Volume</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-600 mb-2">98%</div>
            <div className="text-gray-600">Successful Closings</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-600 mb-2">30 Days</div>
            <div className="text-gray-600">Average Time to Close</div>
          </div>
        </div>
      </div>
    </section>
  );
};
